import { useClientSideTranslation } from 'src/services/i18n'
import { useGetCurrentLanguage } from 'src/store/game'
import type { BetStatus } from 'src/types/domain/BetStatus'
import { betStatusMap } from 'src/types/domain/BetStatus'
import { BetClassNameMap } from 'src/utils/betUtils'

type Props = Readonly<{
  currentBetStatus: BetStatus
}>

export function BetPayoutLabel({ currentBetStatus }: Props) {
  const { t } = useClientSideTranslation(useGetCurrentLanguage())

  const BetPayoutLabelMap: Record<BetStatus, string> = {
    [betStatusMap.WON]: t('Won'),
    [betStatusMap.LOST]: t('Lost'),
    [betStatusMap.CANCELLED]: t('Cancelled'),
    [betStatusMap.PENDING]: t('Potential Win'),
    [betStatusMap.CASHED_OUT]: t('Cashed Out')
  }

  return (
    <span className={`bet-entry__label label--${BetClassNameMap[currentBetStatus]}`}>
      {BetPayoutLabelMap[currentBetStatus]}
    </span>
  )
}
